module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_02-c197efc662a8035fdef5c7162d554c3f.jpg";